// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep #testSelection .mat-grid-tile .mat-figure {
  align-items: flex-start;
}

::ng-deep #testSelection .mat-grid-tile:first-child .mat-figure {
  justify-content: flex-start;
}

::ng-deep #testSelection .mat-grid-tile:last-child .mat-figure {
  justify-content: flex-end;
}

.reportsCheckboxes p,
.creditBox div:first-child p {
  margin-bottom: 6px;
  padding-bottom: 0;
}

.creditBox div:nth-child(2),
.creditBox div:nth-child(3) {
  border: 1px solid #ccc;
}

.creditBox div:nth-child(2) {
  background-color: rgb(208, 238, 207);
  margin-bottom: 5px;
}

.creditBox div:nth-child(3) {
  background-color: #bebebe;
}

.creditBox div:nth-child(2) p,
.creditBox div:nth-child(3) p {
  margin: 0;
  padding: 0;
  text-align: center;
}

.creditsAvailable, .creditCost {
  padding: 6.5px;
}

.creditBoxInner {
  width: 100px;
  margin-bottom: 10px;
}

.creditBoxInner div:first-child p {
  margin-bottom: 6px;
  padding-bottom: 0;
}

.creditBoxInner div:first-child p span,
.reportsCheckboxes p span {
  font-family: MontserratSemiBold, sans-serif;
}

.creditBoxInner div:nth-child(2),
.creditBoxInner div:nth-child(3) {
  border: 1px solid #ccc;
}

.creditBoxInner div:nth-child(2) {
  margin-bottom: 5px;
}

.creditBoxInner div:nth-child(3) {
  background-color: #bebebe;
}

.creditBoxInner div:nth-child(2) p,
.creditBoxInner div:nth-child(3) p {
  margin: 0;
  padding: 0;
  text-align: center;
}

.creditsAvailable, .creditCost {
  padding: 6.5px;
}

.mpoRequestTable {
  width: 100%;
}

.mpoRequestTable .alignRight {
  text-align: right;
}

.alRight {
  position: absolute;
  top: 4px;
  right: 0;
}

.pt10 {
  padding-top: 10px;
}

.surveySectionTitle {
  font-size: 1.5rem;
  padding-bottom: 0;
}
.surveySectionTitle .mat-icon {
  font-size: 24px;
  height: 24px;
  width: 24px;
}

#upButton {
  bottom: 50px;
}

.formWrapper {
  padding-top: 0;
  overflow: auto;
  overflow-y: scroll;
  height: 100vh;
}

.backToList {
  text-align: left;
  width: 33px;
  border-right: 1px #bcbcbc solid;
  border-radius: 0;
  margin-right: 10px;
}

.panelHr {
  margin: 0 0 17px 0;
}

/* input color class */
::ng-deep input.mat-input-element {
  color: #111111;
  font-size: 14px;
  caret-color: #484a4c;
}

.flex-form {
  display: flex;
  flex-direction: column;
}

.flex-form {
  display: flex;
  flex-direction: column;
}

::ng-deep .mat-grid-tile.credit-box-left-align > .mat-grid-tile-content {
  justify-content: flex-start !important;
}

.mpo-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/mobile/mobile-people-request-send-resend/mobile-people-request-send-resend.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AACA;EACI,2BAAA;AAEJ;;AAAA;EACI,yBAAA;AAGJ;;AADA;;EAEI,kBAAA;EACA,iBAAA;AAIJ;;AAFA;;EAEI,sBAAA;AAKJ;;AAFA;EACI,oCAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,yBAAA;AAKJ;;AAFA;;EAEI,SAAA;EACA,UAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,cAAA;AAKJ;;AAFA;EACI,YAAA;EACA,mBAAA;AAKJ;;AAFA;EACI,kBAAA;EACA,iBAAA;AAKJ;;AAHA;;EAEI,2CAAA;AAMJ;;AAJA;;EAEI,sBAAA;AAOJ;;AALA;EACI,kBAAA;AAQJ;;AANA;EACI,yBAAA;AASJ;;AAPA;;EAEI,SAAA;EACA,UAAA;EACA,kBAAA;AAUJ;;AARA;EACI,cAAA;AAWJ;;AARA;EACI,WAAA;AAWJ;;AARA;EACI,iBAAA;AAWJ;;AARA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;AAWJ;;AARA;EACI,iBAAA;AAWJ;;AARA;EACI,iBAAA;EACA,iBAAA;AAWJ;AAVI;EACI,eAAA;EACA,YAAA;EACA,WAAA;AAYR;;AARA;EACI,YAAA;AAWJ;;AARA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AAWJ;;AARA;EACI,gBAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AAWJ;;AARA;EACI,kBAAA;AAWJ;;AARA,sBAAA;AACA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AAWJ;;AATA;EACI,aAAA;EACA,sBAAA;AAYJ;;AATA;EACI,aAAA;EACA,sBAAA;AAYJ;;AATA;EACI,sCAAA;AAYJ;;AATA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAYJ","sourcesContent":["::ng-deep #testSelection .mat-grid-tile .mat-figure {\n    align-items: flex-start;\n}\n::ng-deep #testSelection .mat-grid-tile:first-child .mat-figure {\n    justify-content: flex-start;\n}\n::ng-deep #testSelection .mat-grid-tile:last-child .mat-figure {\n    justify-content: flex-end;\n}\n.reportsCheckboxes p,\n.creditBox div:first-child p {\n    margin-bottom: 6px;\n    padding-bottom: 0;\n}\n.creditBox div:nth-child(2),\n.creditBox div:nth-child(3) {\n    border: 1px solid #ccc;\n}\n\n.creditBox div:nth-child(2) {\n    background-color: rgb(208, 238, 207);\n    margin-bottom: 5px;\n}\n\n.creditBox div:nth-child(3) {\n    background-color: #bebebe;\n}\n\n.creditBox div:nth-child(2) p,\n.creditBox div:nth-child(3) p {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n\n.creditsAvailable, .creditCost {\n    padding: 6.5px;\n}\n\n.creditBoxInner {\n    width: 100px;\n    margin-bottom: 10px;\n}\n\n.creditBoxInner div:first-child p {\n    margin-bottom: 6px;\n    padding-bottom: 0;\n}\n.creditBoxInner div:first-child p span,\n.reportsCheckboxes p span {\n    font-family: MontserratSemiBold,  sans-serif;\n}\n.creditBoxInner div:nth-child(2),\n.creditBoxInner div:nth-child(3) {\n    border: 1px solid #ccc;\n}\n.creditBoxInner div:nth-child(2) {\n    margin-bottom: 5px;\n}\n.creditBoxInner div:nth-child(3) {\n    background-color: #bebebe;\n}\n.creditBoxInner div:nth-child(2) p,\n.creditBoxInner div:nth-child(3) p {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n.creditsAvailable, .creditCost {\n    padding: 6.5px;\n}\n\n.mpoRequestTable {\n    width: 100%;\n}\n\n.mpoRequestTable .alignRight {\n    text-align: right;\n}\n\n.alRight {\n    position: absolute;\n    top: 4px;\n    right: 0;\n}\n\n.pt10 {\n    padding-top: 10px;\n}\n\n.surveySectionTitle {\n    font-size: 1.5rem;\n    padding-bottom: 0;\n    .mat-icon {\n        font-size: 24px;\n        height: 24px;\n        width: 24px;\n    }   \n}\n\n#upButton {\n    bottom: 50px;\n}\n\n.formWrapper {\n    padding-top: 0;\n    overflow: auto;\n    overflow-y: scroll;\n    height: 100vh;\n}\n\n.backToList {\n    text-align: left;\n    width: 33px;\n    border-right: 1px #bcbcbc solid;\n    border-radius: 0;\n    margin-right: 10px;\n}\n\n.panelHr {\n    margin: 0 0 17px 0;\n}\n\n/* input color class */\n::ng-deep input.mat-input-element {\n    color: #111111;\n    font-size: 14px;\n    caret-color: #484a4c;\n}\n.flex-form {\n    display: flex;\n    flex-direction: column;\n}\n\n.flex-form {\n    display: flex;\n    flex-direction: column;\n}\n\n::ng-deep .mat-grid-tile.credit-box-left-align > .mat-grid-tile-content {\n    justify-content: flex-start !important;\n}\n\n.mpo-flex {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
